var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-fields-playground" }, [
    _c("div", { staticClass: "row-title" }, [
      _c("span", { staticClass: "row-text" }, [
        _vm._v(_vm._s(_vm.texts.title)),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "playground-area" },
      [
        _vm.config.customFields && _vm.config.customFields.length
          ? _c("CustomFieldsListComponent", {
              model: {
                value: _vm.customFields,
                callback: function ($$v) {
                  _vm.customFields = $$v
                },
                expression: "customFields",
              },
            })
          : _c("div", { staticClass: "empty-playground" }, [
              _c("span", {
                class: [_vm.emptyPlaygroundIcon, "empty-icon", "lf-icon__xl"],
              }),
              _c("div", { staticClass: "texts-container" }, [
                _c("p", { staticClass: "empty-title" }, [
                  _vm._v(_vm._s(_vm.texts.emptyTitle)),
                ]),
                _c("p", { staticClass: "empty-message" }, [
                  _vm._v(_vm._s(_vm.texts.emptyMessage)),
                ]),
              ]),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }